import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/modules/current-user/permissions/permissions';

export default [
  {
    path: 'sharing',
    name: 'profile-sharing-links',
    component: () => import('./ProfileSharingLinks.vue'),
    meta: {
      permissions: [Permission.SuppliersProfileSharingView],
    },
  },
] satisfies RouteRecordRaw[];
